module.exports = __webpack_public_path__ + "media/images/index/product_line/climbing-acb9afe6a22bc96fecb11b921910db5e.svg";